import { useState, useRef } from 'react';

import IconBtn from 'components/common/IconBtn';
import { ReactComponent as CloseIcon } from 'assets/icons/cross-simple.svg';

import styles from './PreviewTemplate.module.scss';
import PDFViewer from 'components/common/PDFViewer/PDFViewer';

const title = 'Aliro Standard Agreement';

type Props = {
    closePreview: () => void;
};

const PreviewTemplate = ({ closePreview }: Props) => {
    const [template, setTemplate] = useState<string>('/standard_agreement_australia.pdf');
    const pdfViewerRef = useRef<HTMLDivElement | null>(null);
    const [country, setCountry] = useState<string>('Australia');

    const toggleFullscreenMode = () => {
        closePreview();
    };

    const switchTemplate = (country: string) => {
        setCountry(country);
        if (country === 'Canada') setTemplate('/standard_agreement_canada.pdf');
        else if (country === 'Australia') setTemplate('/standard_agreement_australia.pdf');
        else return;
    };
    const styleSelected = { fontWeight: 'bold', color: '#4A52BB' };

    return (
        <div className={styles['document-preview']}>
            <div className={styles['side-padding']}>
                <section className={styles['document-preview__header']}>
                    <h3 className={styles['document-preview__title']}>{title}</h3>
                    <p
                        className={styles['country']}
                        style={country === 'Australia' ? styleSelected : {}}
                        onClick={() => switchTemplate('Australia')}
                    >
                        Australia
                    </p>
                    <p
                        className={styles['country']}
                        style={country === 'Canada' ? styleSelected : {}}
                        onClick={() => switchTemplate('Canada')}
                    >
                        Canada
                    </p>
                    <div className={styles.dashboard}>
                        <IconBtn variant="primary" onClick={toggleFullscreenMode}>
                            <CloseIcon fill="#282828" />
                        </IconBtn>
                    </div>
                </section>
            </div>

            <div className={styles['pdf-viewer__wrapper']}>
                <div ref={pdfViewerRef} className={styles['pdf-viewer']}>
                    <PDFViewer file={template} />
                </div>
            </div>

            <div className={styles['btn-wrapper']}>
                <button
                    className={styles['btn-filled']}
                    type="button"
                    disabled={false}
                    onClick={closePreview}
                >
                    Close
                </button>
            </div>
        </div>
    );
};

export default PreviewTemplate;
